(() => {
  const initialize = (section) => {
    if (section.dataset.iamaranthPressReady === 'true') return;
    section.dataset.iamaranthPressReady = 'true';
    const buttons = section.querySelectorAll('[data-press-filter]');
    const cards = section.querySelectorAll('[data-press-category]');
    const empty = section.querySelector('[data-press-empty]');
    const viewport = section.querySelector('[data-press-viewport]');
    const previous = section.querySelector('[data-press-prev]');
    const next = section.querySelector('[data-press-next]');
    const updateNavigation = () => {
      if (!viewport || !previous || !next) return;
      const maximum = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      previous.disabled = viewport.scrollLeft <= 2;
      next.disabled = viewport.scrollLeft >= maximum - 2;
    };
    const setFilter = (filter) => {
      let visible = 0;
      cards.forEach((card) => {
        const matches = filter === 'all' || card.dataset.pressCategory === filter;
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      buttons.forEach((button) => {
        const active = button.dataset.pressFilter === filter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (empty) empty.hidden = visible !== 0;
      if (viewport) viewport.scrollTo({ left: 0, behavior: 'auto' });
      requestAnimationFrame(updateNavigation);
    };
    buttons.forEach((button) => button.addEventListener('click', () => setFilter(button.dataset.pressFilter)));
    if (viewport && previous && next) {
      const scrollByPage = (direction) => viewport.scrollBy({ left: direction * viewport.clientWidth * .94, behavior: 'smooth' });
      previous.addEventListener('click', () => scrollByPage(-1));
      next.addEventListener('click', () => scrollByPage(1));
      viewport.addEventListener('scroll', updateNavigation, { passive: true });
      window.addEventListener('resize', updateNavigation, { passive: true });
      updateNavigation();
    }
  };
  const initializeAll = () => document.querySelectorAll('[data-iamaranth-press]').forEach(initialize);
  document.addEventListener('DOMContentLoaded', initializeAll);
  document.addEventListener('shopify:section:load', initializeAll);
})();
